import React from "react";
import { PenLine, UserRound } from "lucide-react";
import { Avatar, AvatarFallback } from "../../atoms/Avatar/index.js";
import { IconTile } from "../../atoms/IconTile/index.js";
import { initialsOf } from "../../lib/initials.js";
import type { PeopleFieldChipView } from "./people-field-chip.js";

/**
 * The 24px mark beside a name in the chip and the list. A person is their own
 * colour, seeded by id (d36), so they look the same here as on the roster; a
 * person who is not active is the quiet neutral disc; a typed name is a pen
 * and an id nobody knows is a plain person outline. Always decorative: the
 * name beside it is what is read.
 */
export function PeopleFieldAvatar({
  kind,
  seed,
  name,
}: {
  readonly kind: PeopleFieldChipView["avatar"];
  /** The person's id. */
  readonly seed: string | undefined;
  readonly name: string;
}): React.ReactElement {
  if (kind === "typed" || kind === "unknown") {
    return (
      <IconTile size="xs" shape="circle" variant="outline">
        {kind === "typed" ? <PenLine /> : <UserRound />}
      </IconTile>
    );
  }
  return (
    <Avatar
      size="xs"
      aria-hidden="true"
      {...(kind === "inactive" || seed === undefined
        ? { tone: "neutral" as const }
        : { seed })}
    >
      <AvatarFallback>{initialsOf(name)}</AvatarFallback>
    </Avatar>
  );
}
